import React from 'react'
import { useTranslation } from 'react-i18next';

export const ExpiredDisbursementsCard = ({ quantity }) => {
  const { t } = useTranslation();

  return (
    <div className="deadlines">
      <div className="c-pending">
        <span className='pending-value'><p>{quantity}</p></span>
        <p className='chart-title' style={{ height: 'auto', textAlign: 'center' }}>
          {t('one_pager_report.projects_with_deadlines')}
        </p>
      </div>
    </div>
  )
}
